export const configuracaoAneisSilo = {
    cor: '#7E7E7E',
    width: 3,
    pixel: 3779.527559,
};
